export const example = {
    register:"注册西八",
    signin:"登陆西八",
    home: "首页西八"
}
